// extracted by css-extract-rspack-plugin
export default {"format-example":"AWqW4ux9_0AzfkUZ","formatExample":"AWqW4ux9_0AzfkUZ"};